import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'search-site',
  templateUrl: './search-site.component.html',
  styleUrls: ['./search-site.component.css']
})
export class SearchSiteComponent implements OnInit {

  constructor(private _router:Router) { }

  ngOnInit() {
  }
  search()
  {
    var search = (<HTMLInputElement>document.getElementById('search')).value ;
    (<HTMLInputElement>document.getElementById('search')).value = "" ;
    this._router.navigate(["/Movie/Search",search.toUpperCase()])

  }

}
